import IconButton from './icon-button';
export type { IconButtonProps } from './icon-button.types';
export default IconButton;
